module.exports = __webpack_public_path__ + "static/media/6 - Miel De Montagne - Relax le plexus.ef9464e1.mp3";